import React, { useState } from 'react';
import { X } from 'lucide-react';

const SpacerModal = ({ isOpen, onClose, onConfirm, initialValue = 10 }) => {
  // Force initial value between 1-10
  const [value, setValue] = useState(Math.min(Math.max(initialValue, 1), 10));

  const handleIncrement = () => {
    setValue(prev => Math.min(prev + 1, 10));
  };

  const handleDecrement = () => {
    setValue(prev => Math.max(prev - 1, 1));
  };

  const handleConfirm = () => {
    onConfirm(value);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-xs relative mx-4">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold text-gray-800">Spacer Configuration</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-red-600 transition-colors" aria-label="Close" >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-5">
          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-2"> Spacer Width (ft) </label>
            <div className="flex items-center justify-between">
              <button onClick={handleDecrement} disabled={value <= 1} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-lg hover:bg-red-50 hover:text-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" >
                -
              </button>
              
              <div className="mx-3 flex-1 text-center">
                <input type="number" readOnly className="w-20 text-center text-2xl font-bold text-red-600 border rounded bg-gray-50 cursor-default" value={value} min="1" max="10" />
                <span className="ml-1 text-gray-500">ft</span>
              </div>
              
              <button onClick={handleIncrement} disabled={value >= 10} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-lg hover:bg-red-50 hover:text-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" >
                +
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2 text-center"> Allowed range: 1-10ft </p>
          </div>

          <div className="flex justify-end gap-2 pt-4 border-t">
            <button onClick={onClose} className="px-3 py-1.5 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm" >
              Cancel
            </button>
            <button onClick={handleConfirm} className="px-3 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors focus:ring-2 focus:ring-red-500 focus:ring-offset-2 text-sm" >
              Add Spacer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpacerModal;
